import { useEffect, useState } from "react";

const navLinks = [
  { href: "#features", label: "核心功能" },
  { href: "#recommend", label: "热门推荐" },
  { href: "#scenarios", label: "阅读场景" },
  { href: "#voices", label: "用户口碑" },
  { href: "#faq", label: "常见问题" },
  { href: "#about", label: "关于我们" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-background-50/95 backdrop-blur-md shadow-sm" : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6" aria-label="主导航">
        <a href="#top" className="flex items-center gap-2 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-book-2-line text-lg"></i>
          </span>
          <span className="font-heading text-xl text-primary-600">尾巴漫画网</span>
        </a>

        <div className="hidden items-center gap-1 md:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="rounded-full px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-secondary-100 hover:text-secondary-900"
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="hidden items-center gap-2 md:flex">
          <a
            href="#about"
            className="whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-200"
          >
            登录
          </a>
          <a
            href="#features"
            className="whitespace-nowrap rounded-full bg-primary-500 px-5 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            开始阅读
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-lg text-foreground-900 md:hidden"
          aria-label="打开菜单"
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-2xl`}></i>
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 md:hidden">
          <div className="mx-auto flex max-w-7xl flex-col gap-1 px-4 py-4">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="rounded-lg px-4 py-3 text-sm font-medium text-foreground-700 transition-colors hover:bg-secondary-100"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#features"
              onClick={() => setOpen(false)}
              className="mt-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-3 text-center text-sm font-medium text-background-50"
            >
              开始阅读
            </a>
          </div>
        </div>
      )}
    </header>
  );
}